import React from 'react'
import {IndicatorViewPager, Label, StarRating} from "components/src/components";
import {ActivityIndicator, Image, ScrollView, TouchableOpacity, View} from 'react-native'
import styles from './styles';
import {Color, CommonStyle, Constants, openInNewTab, Strings, ThemeUtils} from "components/src/utils";
import PagerDotIndicator from "components/src/components/ui/viewpager/indicator/PagerDotIndicator";
import {useQuery} from "@apollo/react-hooks";
import {PROPERTY_DETAILS} from "../../../../../../../api/query";
import {connect} from "react-redux";
import HtmlView from "../../../../../../../components/view/HTMLView";


function Broker(props) {

    const {inspection} = props;
    const {property} = inspection

    const {loading, data, error} = useQuery(PROPERTY_DETAILS, {
        variables: {
            id: property?.id
        }
    })

    const renderTestimonials = (item, index) => {
        return (
            <View style={styles.testimonialCont}
                  key={index.toString()}>
                <StarRating rating={item.rating}/>
                <Label small
                       color={Color.TERNARY_TEXT_COLOR}
                       align={'center'}>
                    {item?.feedback}
                </Label>
                <Label small
                       font_medium
                       align={'center'}>
                    {item?.given_by}
                </Label>
            </View>
        )
    };

    const renderIndicator = () => {
        return (
            <PagerDotIndicator pageCount={10}/>
        )
    };
    const renderMedia = (item, index) => {
        return (
            <TouchableOpacity activeOpacity={0.5}
                              onPress={() => {
                                  openInNewTab(item?.redirect_url)
                              }}
                              style={styles.mediaImgCont}
                              key={index.toString()}>
                <Image style={styles.mediaImage}
                       source={{uri: `${Constants.APIConfig.STORAGE_URL}${item.media_url}`}}/>
                <Label small
                       mt={ThemeUtils.relativeRealHeight(2)}
                       numberOfLines={2}>
                    {item?.title}
                </Label>
            </TouchableOpacity>
        )
    }

    return (
        <View style={CommonStyle.flex}>
            {loading && !data ? (
                <ActivityIndicator color={Color.PRIMARY}
                                   style={CommonStyle.loader}/>
            ) : (
                <View style={[styles.container]}>
                    <View>
                        <Image style={styles.img}
                               source={{uri: `${Constants.APIConfig.STORAGE_URL}${data?.property?.agent?.profile_image}`}}/>
                        <View style={styles.imgCont}>
                            <View style={styles.lblCont}>
                                <Label small
                                       font_medium>
                                    {Strings.title}
                                </Label>
                                <Label small
                                       mt={5}
                                       mb={15}>
                                    {data?.property?.agent?.title}
                                </Label>
                                <Label small
                                       font_medium>
                                    {Strings.education}
                                </Label>
                                <Label small
                                       mt={5}
                                       mb={15}>
                                    {data?.property?.agent?.user_detail?.education}
                                </Label>
                                <Label small
                                       font_medium>
                                    {Strings.office}
                                </Label>
                                <Label small
                                       mt={5}
                                       mb={15}>
                                    {data?.property?.agent?.office?.name}
                                </Label>
                            </View>
                            <View style={styles.divider}/>
                        </View>
                    </View>

                    <ScrollView>

                        <View style={styles.contentCont}>
                            <Label xxlarge
                                   font_medium
                                   mt={20}>
                                {`${data?.property?.agent?.first_name ?? ""} ${data?.property?.agent?.last_name ?? ""}`}
                            </Label>
                            <Label color={Color.TERNARY_TEXT_COLOR}
                                   mt={10}
                                   mb={10}>
                                {data?.property?.agent?.title}
                            </Label>

                            <Label small
                                   mt={20}
                                   mb={5}
                                   font_medium>
                                {`${Strings.summary} ${data?.property?.agent?.first_name ?? ""} ${data?.property?.agent?.last_name ?? ""}`}
                            </Label>

                            <HtmlView value={data?.property?.agent?.user_detail?.about}/>

                            {data?.property?.agent?.feedback.length ? (
                                <Label small
                                       mt={20}
                                       mb={10}
                                       font_medium>
                                    {Strings.testimonial}
                                </Label>) : null}

                            {data?.property?.agent?.feedback.length ? (
                                <IndicatorViewPager style={styles.pager}>
                                    {data?.property?.agent?.feedback.map(renderTestimonials)}
                                </IndicatorViewPager>) : null}


                            {data?.property?.agent?.user_media.length ? (
                                <Label small
                                       font_medium
                                       mb={ThemeUtils.relativeRealHeight(1)}>
                                    {Strings.media}
                                </Label>) : null}

                            <ScrollView horizontal>
                                {data?.property?.agent?.user_media.map(renderMedia)}
                            </ScrollView>
                        </View>
                    </ScrollView>
                </View>
            )}
        </View>
    )
}

const mapStateToProps = (state) => {

    return {
        inspection: state.inspection,
    };
};
export default connect(mapStateToProps)(Broker)
